import { Vue, Component } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import Loading from "@/components/loading/loading";
@Component({
  components: { Loading },
})
export default class AutoLogin extends Vue {
  @Action action_autoLogin: any;
  @Action action_getAllSubscriptions: any;

  @Getter getIsToken: any;
  @Getter getCity;

  isFetchingUser = false;

  async mounted() {
    localStorage.setItem("_tc", "");
    const providedToken = this.$route.query.token;
    try {
      this.isFetchingUser = true;
      await this.action_autoLogin(providedToken);
      this.isFetchingUser = false;
      this.$router.replace({ path: "/mi-menu/mis-pedidos" });
    } catch (error) {
      this.$router.replace({ path: "/ingresar/login" });
    }
  }
}
